import urlFormatter from 'url'

import axios, { AxiosError, AxiosRequestConfig } from 'axios'
import get from 'lodash/get'

import { ErrorResponse } from '../types.ts'
import { APP_ROUTES } from '../constants.ts'
import { router } from '../router'

import { ServiceHTTPMethods, ApiClientOptions, RequestHandler } from './services.types.ts'
import { AppDispatch } from '@/stores'
import { userActions } from '@/stores/slices/user-slice.ts'

export const APP_ROOT_API = '/acq-company-rest/lk'
export const APP_ROOT_DOMAIN = () => get(window, '__CONFIG__.apiurl', '') as string

export const axiosInstance = axios.create({
  baseURL: `${APP_ROOT_DOMAIN()}${APP_ROOT_API}`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
  validateStatus: (status) => status >= 200 && status < 300,
})

// https://github.com/TanStack/query/discussions/1385#discussioncomment-3113979
export const logoutInterceptor = (dispatch: AppDispatch) =>
  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.status === 403) {
        throw response
      }
      return response
    },
    (error: AxiosError<ErrorResponse>) => {
      if (error?.response?.data.errorType === 'NOT_AUTHORIZED') {
        dispatch(userActions.resetUser())
        // todo: reset queries
        router.navigate(APP_ROUTES.Login)
      }

      return Promise.reject(error)
    }
  )

// todo: abortcontroller test
// https://github.com/axios/axios#abortcontroller
const createClientMethod =
  (method: ServiceHTTPMethods) =>
  (url: string, options: ApiClientOptions = {}) => {
    const { queryParams, bodyParams, headerParams, axiosParams } = options

    const requestUrl = urlFormatter.format({ pathname: url, query: queryParams })
    const requestParams: AxiosRequestConfig = {
      method,
      url: requestUrl,
      headers: headerParams,
      data: bodyParams,
      ...axiosParams,
    }
    return axiosInstance(requestParams)
  }

export const apiService: Record<ServiceHTTPMethods, RequestHandler> = {
  get: createClientMethod('get'),
  post: createClientMethod('post'),
  put: createClientMethod('put'),
  patch: createClientMethod('patch'),
  delete: createClientMethod('delete'),
}
